import { render, staticRenderFns } from "./StartGameSec.vue?vue&type=template&id=70226c1f&scoped=true"
import script from "./StartGameSec.vue?vue&type=script&lang=js"
export * from "./StartGameSec.vue?vue&type=script&lang=js"
import style0 from "./StartGameSec.vue?vue&type=style&index=0&id=70226c1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70226c1f",
  null
  
)

export default component.exports